import { render, staticRenderFns } from "./FaqsModal.vue?vue&type=template&id=f885afc2&scoped=true&"
import script from "./FaqsModal.vue?vue&type=script&lang=js&"
export * from "./FaqsModal.vue?vue&type=script&lang=js&"
import style0 from "./FaqsModal.vue?vue&type=style&index=0&id=f885afc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f885afc2",
  null
  
)

export default component.exports